import type { AuditInfo } from "./schemas";

const dateFormatter = new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
});

export function formatTimestamp(value: string | null | undefined): string {
    if (value === null || value === undefined || value === "") {
        return "—";
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }
    return dateFormatter.format(parsed);
}

export function formatActor(audit: AuditInfo | null | undefined): string {
    if (audit === null || audit === undefined) {
        return "—";
    }
    if (audit.actor === null || audit.actor === undefined || audit.actor === "") {
        return formatTimestamp(audit.timeStamp);
    }
    return `${audit.actor} · ${formatTimestamp(audit.timeStamp)}`;
}
